@if (stepOne) {
    <app-first-time-user-experience-step-one
        [educationalLevels$]="educationalLevels$"
        [userData]="ftuxService.userData"
        (nextEmitter)="onNextStepOne($event)"
        (closeEmitter)="onClose()">
    </app-first-time-user-experience-step-one>
} @else if (stepTwo) {
    <app-first-time-user-experience-step-two
        (nextEmitter)="onNextStepTwo($event)"
        [groups]="groups"
        [educationalLevelStarter]="educationalLevelStarter"
        (close)="onClose()">
    </app-first-time-user-experience-step-two>
}
